import apiClient from '../client';

export type SAVStatistics = {
  totalReports: number;
  reportsByStatus: { Pending: number; Seen: number; Accounted: number };
  reportsByInterventionType: { 'Start-Up': number; Repair: number; Unknown: number };
  totalRevenue: number;
  averageInterventionPrice: number;
  warrantyDistribution: { Active: number; Expired: number; Consumed: number; Exception: number; Unknown: number };
  topAgent: { displayName: string; reportsCount: number } | null;
  mostReportedBrand: { brandName: string; reportedUnitsCount: number } | null;
  mostReportedProduct: { productName: string; reportedUnitsCount: number } | null;
  reportsPerState: { [key: string]: number };
  registeredAgentsPerState: { [key: string]: number };
};

export async function fetchSavStatistics(): Promise<SAVStatistics> {
  const response: any = await apiClient.get('/sav/statistics');
  return response.data || response;
}

/**
 * Export SAV dashboard KPIs as Excel (.xlsx).
 * Sends the already-fetched stats object to avoid re-computing on the backend.
 */
export async function exportSavStatistics(stats: SAVStatistics): Promise<void> {
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000/api/v1';
  const token = localStorage.getItem('authToken');

  const response = await fetch(`${apiBaseUrl}/sav/statistics/export`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify({ stats }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error?.message || 'Failed to export KPIs');
  }

  const contentDisposition = response.headers.get('Content-Disposition');
  let fileName = `kpis_sav_${new Date().toISOString().slice(0, 10)}.xlsx`;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    if (match?.[1]) fileName = decodeURIComponent(match[1].replace(/['"]/g, ''));
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}
